import styled from 'styled-components';

const EllipsisWrapper = styled.div`
  font-weight: 600;
  margin-right: 10px;
  color: ${props => props.theme.color.black};
`;

export default EllipsisWrapper;